
import Server from "src/server";
import Util from "src/util/util";

export default
  {
    namespaced: true,
    state:
    {
      isLoading: false,
      defaultEmailConnection: {},
      connections: []
    },

    mutations:
    {

    },

    actions:
    {
      reset(context) {
        context.state.connections = [];
      },

      async setConnections(context) {
        try {
          let workspace = context.rootState.wsStore.workspace;
          if(!workspace)
            return;
          context.state.isLoading = true;
          var result = await Server.post("getConnections", { workspace }).promise;
          context.state.isLoading = false;
          if(!result.data.success)
            throw(result.data.error);
          context.state.connections = result.data.connections;
          return result;
        }
        catch(e) {
          console.log("Failed 'getConnections' server call. " + e.toString());
          context.state.isLoading = false;
          return {data:{success: false, error: e}};
        }
      },

      async insertConnection(context, { connection }) {
        try {
          let workspace = context.rootState.wsStore.workspace;
          connection.workspace = workspace;
          var result = await Server.post("insertConnection", { connection: connection }).promise;
          if(!result.data.success)
            throw(result.data.error);

          context.state.connections.push(result.data.connection)
          return result;
        }
        catch(e) {
          console.log("Failed 'insertConnection' server call. " + e.toString());
          return {data:{success: false, error: e}};
        }
      },

      async updateConnection(context, { connection }) {
        try {
          var result = await Server.post("updateConnection", { connection: connection }).promise;
          if(!result.data.success)
            throw(result.data.error);

          context.state.connections = Util.replaceInArray(context.state.connections, "_id", result.data.connection);
          return result;
        }
        catch(e) {
          console.log("Failed 'updateConnection' server call. " + e.toString());
          return {data:{success: false, error: e}};
        }
      },

      async updateSchemas(context, { connection }) {
        try {
          var result = await Server.post("updateSchemas", { connection: connection }).promise;
          if(!result.data.success)
            throw(result.data.error);

          context.state.connections = Util.replaceInArray(context.state.connections, "_id", result.data.connection);
          // update each node in the current workflow that has this connection

          return result;
        }
        catch(e) {
          console.log("Failed 'updateSchemas' server call. " + e.toString());
          return {data:{success: false, error: e}};
        }
      },

      async deleteConnection(context, { connection }) {
        try {
          var result = await Server.post("deleteConnection", { connection: connection }).promise;
          if(!result.data.success)
            throw(result.data.error);

          context.state.connections = Util.removeFromArrayByKey(context.state.connections, "_id", connection._id);
          return result;
        }
        catch(e) {
          console.log("Failed 'deleteConnection' server call. " + e.toString());
          return {data:{success: false, error: e}};
        }
      }
    },

    getters:
    {

      getInputOutputConns: (state) => {
        return state.connections.filter(a => a.type != "geometry");
      },

      getGISConns: (state) => {
        return state.connections.filter(a => a.type == "esri" || a.type == "agol");
      },

      getGISServerConns: (state) => {
        return state.connections.filter(a => a.type == "esri");
      },

      getAGOLConns: (state) => {
        return state.connections.filter(a => a.type == "agol");
      },

      getMaximoConns: (state) => {
        return state.connections.filter(a => a.type == "max");
      },

      getGeometryConns: (state) => {
        return state.connections.filter(a => a.type == "geometry");
      },

      getEmailConns: (state) => {
        return state.connections.filter(a => a.type == "email");
      },
    }
  };



// WEBPACK FOOTER //
// ./src/store/connection.js